import { createTheme as MUIcreateTheme } from "@mui/material/styles";

import { ruRU } from '@mui/material/locale';

export default function createTheme(props) {
    // const { palette } = props;
    const rootFontSize = 12;

    return MUIcreateTheme({
        props: {
            MuiButtonBase: {
                disableRipple: true,
            },
        },
        rootFontSize,
        spacing: 4,
        rootBackground: 'transparent',
        // palette: { ...palette },
        components: {
            MuiInputBase: {
                styleOverrides: {
                  input: {
                    "&:-webkit-autofill": {
                      transitionDelay: "9999s",
                      transitionProperty: "background-color, color",
                    },
                  },
                },
              },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        // backgroundColor: "#3c3c3c",
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        // color: "#777777",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '4px',
                        textTransform: "none",
                        lineHeight: "2",
                        '& svg': {
                            color: 'inherit',
                            marginRight: '4px',
                            marginLeft: '-8px',
                            fontSize: "26px !important"
                        },
                        '&:hover': {
                            boxShadow: '0px 5px 10px rgba(91, 83, 122, 0.3)',
                        },
                        '&.Mui-disabled ': {
                            // backgroundColor: "#5966f0",
                            // color: "#FFF",
                            // opacity: 0.6,
                        },
                        "& .MuiButton-endIcon": {
                            right: 6,
                            position: "absolute",
                        }
                    },
                    label: {
                        textTransform: "uppercase",
                        textAlign: "center",
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        "&.Mui-selected": {
                            // "color": "#fff"
                        }
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        // color: "#777",
                        // fontSize: "0.8rem !important",
                    },
                    subtitle2: {
                        marginBottom: 14,
                        fontSize: "1rem !important",
                        color: "#35588b",
                    },
                },
            }
        },
        typography: {
            useNextVariants: true,
            fontSize: rootFontSize,
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            textAlign: "center",
            letterSpacing: "0.03em",
        }
    },ruRU);
}